/* ==========================================================================
   mxm-combo.js — página y colección Más x Menos (ModaEZ)
   Lo carga sections/mxm-combo.liquid. Las tarjetas ya vienen dibujadas desde el servidor
   (snippets/mxm-tarjeta.liquid); este archivo sólo:
     · lee las dos filas de talla del encabezado (sections/mxm-hero.liquid): la talla de jean
       afecta SÓLO a los jeans y la de body SÓLO a los bodys;
     · llena el recuadro de acción de cada tarjeta (Elegir talla / colores / Agregar · 42 /
       Sin tu talla) y pliega bajo «Ver los N sin tu talla» los que no tienen la talla;
     · recuerda la talla (localStorage, siempre dentro de try/catch) y lee ?talla=42 y
       ?talla_body=M de la dirección (la dirección gana);
     · agrega al carrito con un toque y refresca la burbuja y el carrito lateral sin abrirlo;
     · pinta la barra de abajo contando en /cart.js SÓLO las prendas de la colección;
     · «Ver carrito» abre el carrito lateral (si no existe, va a /cart).
   Sin librerías y sin barras invertidas (LECCIONES C3).

   2026-10-17 — relanzamiento «prendas». Reemplaza la versión del 2-ago, que dibujaba todo con
   innerHTML, tenía un solo selector de talla que apagaba los bodys y usaba verde y rojo.

   TRAMPAS APRENDIDAS (no deshacer sin leer):
   1. CLP llega ×100 desde Shopify ($29.990 = 2999000). Dividir al imprimir.
   2. `final_line_price` YA trae el descuento automático. «Aplicado» se decide por el título del
      descuento en la línea («Más x Menos…», sin «Brillos», que es la cápsula Luz Propia): los
      descuentos automáticos no se suman entre sí y Shopify puede elegir otro.
   3. No re-dibujar las tarjetas con innerHTML: se mueven los mismos nodos (así las estrellas de
      Loox y las fotos ya cargadas no se pierden). Sólo se reescribe el recuadro [data-accion].
   4. Los colores de un body se muestran DESPUÉS de elegir talla (Javier, 2-ago-2026): antes salían
      todos los colores de todas las tallas juntos. Con talla, se elige solo el primer color con
      stock (o el color preferido de la tarjeta, p. ej. B07 negro).
   5. Dawn reemplaza el interior de #CartDrawer al renderizar: hay que volver a enganchar el clic
      del fondo oscuro (#CartDrawer-Overlay) y sacar/poner la clase is-empty de <cart-drawer>.
   ========================================================================== */
(function () {
  'use strict';

  var LS = { jean: 'ez_mxm_talla_jean', body: 'ez_mxm_talla_body' };
  var PARAM = { jean: 'talla', body: 'talla_body' };
  var ORDEN_LETRAS = ['XS', 'S', 'M', 'L', 'XL', '2XL', 'XXL', '3XL', 'XXXL'];

  function leerLS(k) {
    try { return window.localStorage.getItem(k); } catch (e) { return null; }
  }
  function guardarLS(k, v) {
    try {
      if (v) window.localStorage.setItem(k, v);
      else window.localStorage.removeItem(k);
    } catch (e) {}
  }
  function param(n) {
    try { return new URLSearchParams(window.location.search).get(n); } catch (e) {}
    var q = window.location.search.replace('?', '').split('&');
    for (var i = 0; i < q.length; i++) {
      var par = q[i].split('=');
      if (par[0] === n) {
        try { return decodeURIComponent(par[1] || ''); } catch (e2) { return par[1] || ''; }
      }
    }
    return null;
  }
  function esc(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }
  function clarityEv(ev) {
    try { if (typeof window.clarity === 'function') window.clarity('event', ev); } catch (e) {}
  }
  function normTalla(g, t) {
    if (t == null) return null;
    t = String(t).trim();
    if (!t) return null;
    return g === 'body' ? t.toUpperCase() : t;
  }
  function ordenLetra(a, b) {
    var ia = ORDEN_LETRAS.indexOf(String(a).toUpperCase());
    var ib = ORDEN_LETRAS.indexOf(String(b).toUpperCase());
    return (ia < 0 ? 99 : ia) - (ib < 0 ? 99 : ib);
  }
  function ordenNum(a, b) { return parseFloat(a) - parseFloat(b); }
  function esMxm(t) {
    t = String(t || '').toLowerCase();
    return (t.indexOf('más x menos') === 0 || t.indexOf('mas x menos') === 0) && t.indexOf('brillos') === -1;
  }
  function htmlSeccion(html, selector) {
    try {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var el = doc.querySelector(selector);
      return el ? el.innerHTML : null;
    } catch (e) { return null; }
  }

  function arrancar(raiz) {
    var nodo = raiz.querySelector('[data-mxm-datos]');
    if (!nodo) return;
    var D;
    try { D = JSON.parse(nodo.textContent); } catch (e) { return; }
    var P = D.prod || {};
    var TXT = D.txt || {};
    var U1 = parseInt(D.u1, 10) || 2;
    var U2 = parseInt(D.u2, 10) || 3;
    var IDS = (D.ids || []).map(Number);
    var RUTA_ADD = raiz.getAttribute('data-cart-add') || '/cart/add';
    var RUTA_CART = raiz.getAttribute('data-cart') || '/cart';

    var tarjetas = [].slice.call(raiz.querySelectorAll('[data-mxm-card]'));
    var secciones = [].slice.call(raiz.querySelectorAll('[data-mxm-sec]'));
    var filas = {
      jean: document.querySelector('[data-mxm-chips="jean"]'),
      body: document.querySelector('[data-mxm-chips="body"]')
    };
    var nav = raiz.querySelector('[data-mxm-nav]');
    var botonesNav = nav ? [].slice.call(nav.querySelectorAll('[data-ir]')) : [];

    /* Tallas con stock que existen en cada grupo (sirven para validar la URL y lo guardado). */
    var tallas = { jean: [], body: [] };
    var hay = { jean: false, body: false };
    Object.keys(P).forEach(function (pid) {
      var pr = P[pid];
      if (!tallas[pr.g]) return;
      hay[pr.g] = true;
      pr.v.forEach(function (v) {
        if (v.d && v.t && tallas[pr.g].indexOf(v.t) === -1) tallas[pr.g].push(v.t);
      });
    });

    function inicial(g) {
      var u = normTalla(g, param(PARAM[g]));
      if (u && tallas[g].indexOf(u) !== -1) { guardarLS(LS[g], u); return u; }
      var l = normTalla(g, leerLS(LS[g]));
      if (l && tallas[g].indexOf(l) !== -1) return l;
      return null;
    }
    var sel = { jean: inicial('jean'), body: inicial('body') };
    var colorSel = {};
    var ultimoConteo = null;

    function dispDe(pr, t) {
      return pr.v.filter(function (v) { return v.d && (!t || v.t === t); });
    }
    function tallasDe(pr) {
      var out = [];
      pr.v.forEach(function (v) { if (v.d && out.indexOf(v.t) === -1) out.push(v.t); });
      return out.sort(pr.g === 'jean' ? ordenNum : ordenLetra);
    }
    function coloresDe(disp) {
      var vistos = [];
      var out = [];
      disp.forEach(function (v) {
        if (v.c != null && v.c !== '' && vistos.indexOf(v.c) === -1) { vistos.push(v.c); out.push(v); }
      });
      return out;
    }

    /* ---------- Encabezado: filas de talla y estado ---------- */
    function pintarFilas() {
      ['jean', 'body'].forEach(function (g) {
        var fila = filas[g];
        if (!fila) return;
        [].forEach.call(fila.querySelectorAll('[data-talla]'), function (b) {
          b.setAttribute('aria-pressed', String(b.getAttribute('data-talla') === sel[g]));
        });
        var est = fila.querySelector('[data-mxm-estado]');
        if (!est) return;
        var t = sel[g];
        if (!t) { est.textContent = ''; return; }
        var n = 0;
        Object.keys(P).forEach(function (pid) {
          if (P[pid].g === g && dispDe(P[pid], t).length) n++;
        });
        var txt;
        if (g === 'jean') {
          txt = n === 0 ? 'Ningún jean en tu talla ' + t + ' por ahora'
            : n + (n === 1 ? ' jean' : ' jeans') + ' en tu talla ' + t;
          if (hay.body) txt += ' · los bodys siguen disponibles';
        } else {
          txt = n === 0 ? 'Ningún body en tu talla ' + t + ' por ahora'
            : n + (n === 1 ? ' body' : ' bodys') + ' en tu talla ' + t;
          if (hay.jean) txt += ' · los jeans siguen disponibles';
        }
        est.textContent = txt;
      });
    }

    /* ---------- Tarjeta: recuadro de acción y foto ---------- */
    function fotoDe(img, v) {
      if (!img) return;
      if (!img.hasAttribute('data-src0')) {
        img.setAttribute('data-src0', img.getAttribute('src') || '');
        img.setAttribute('data-srcset0', img.getAttribute('srcset') || '');
      }
      if (v && v.i) {
        if (img.getAttribute('src') !== v.i) {
          img.removeAttribute('srcset');
          img.setAttribute('src', v.i);
        }
      } else {
        var s0 = img.getAttribute('data-src0');
        var ss0 = img.getAttribute('data-srcset0');
        if (img.getAttribute('src') !== s0) {
          img.setAttribute('src', s0);
          if (ss0) img.setAttribute('srcset', ss0);
        }
      }
    }

    function pintarTarjeta(card) {
      var pid = card.getAttribute('data-pid');
      var pr = P[pid];
      var acc = card.querySelector('[data-accion]');
      if (!pr || !acc) return;
      var g = pr.g;
      var t = sel[g];
      var disp = dispDe(pr, t);
      var sin = !!t && disp.length === 0;
      card.classList.toggle('mxm-c--sin', sin);
      var html = '';
      var vFoto = null;

      if (!t) {
        if (card.getAttribute('data-abierta') === '1') {
          html = '<p class="mxm-c__tlbl">Tu talla de ' + (g === 'body' ? 'body' : 'jean') +
            ' (queda elegida en toda la página)</p><div class="mxm-c__tallas">' +
            tallasDe(pr).map(function (x) {
              return '<button type="button" class="mxm-c__talla" data-elige="' + esc(x) + '" data-g="' + g + '">' + esc(x) + '</button>';
            }).join('') + '</div>';
        } else {
          html = '<button type="button" class="mxm-btn mxm-btn--fant" data-abrir>Elegir talla</button>';
        }
      } else if (sin) {
        html = '<p class="mxm-c__sin">Sin tu talla ' + esc(t) + '</p>' +
          '<a class="mxm-btn mxm-btn--fant" href="' + esc(pr.u) + '">Ver otras tallas</a>';
      } else {
        var v = disp[0];
        var colores = coloresDe(disp);
        if (colores.length) {
          var c = colorSel[pid];
          var ok = false;
          colores.forEach(function (x) { if (x.c === c) ok = true; });
          if (!ok) {
            c = null;
            var pref = (card.getAttribute('data-color-pref') || '').toLowerCase();
            if (pref) colores.forEach(function (x) { if (!c && String(x.c).toLowerCase() === pref) c = x.c; });
            // QA 17-oct: sin preferido, primero un color que tenga foto. Un color sin foto (B04-Colaless
            // «Cafe Claro») dejaba la foto principal (negro) con el texto «Cafe Claro» debajo.
            if (!c) colores.forEach(function (x) { if (!c && x.i) c = x.c; });
            if (!c) c = colores[0].c;
          }
          colores.forEach(function (x) { if (x.c === c) v = x; });
          vFoto = v;
          html = '<div class="mxm-c__sws" role="group" aria-label="Color">' + colores.map(function (x) {
            var on = x.c === c;
            if (x.s) {
              return '<button type="button" class="mxm-c__sw" aria-pressed="' + on + '" aria-label="' + esc(x.c) +
                '" title="' + esc(x.c) + '" data-color="' + esc(x.c) + '"><img src="' + esc(x.s) +
                '" alt="" width="80" height="80" decoding="async"></button>';
            }
            return '<button type="button" class="mxm-c__sw mxm-c__sw--txt" aria-pressed="' + on + '" data-color="' + esc(x.c) + '">' + esc(x.c) + '</button>';
          }).join('') + '</div><p class="mxm-c__color">' + esc(c) + '</p>';
        }
        html += '<button type="button" class="mxm-btn" data-add="' + v.id + '">Agregar · ' + esc(t) + '</button>';
      }
      acc.innerHTML = html;
      fotoDe(card.querySelector('.mxm-c__foto img'), vFoto);
    }

    /* ---------- Sección: plegar los que no tienen la talla ---------- */
    function pintarSeccion(sec) {
      var g = sec.getAttribute('data-grupo');
      var t = sel[g];
      var main = sec.querySelector('[data-mxm-grid]');
      var pleg = sec.querySelector('[data-mxm-pleg]');
      var pgrid = sec.querySelector('[data-mxm-pleg-grid]');
      var pbtn = sec.querySelector('[data-mxm-pleg-btn]');
      var filtro = sec.querySelector('[data-mxm-filtro]');
      if (!main) return;
      var cards = [].slice.call(sec.querySelectorAll('[data-mxm-card]')).sort(function (a, b) {
        return parseInt(a.getAttribute('data-orden'), 10) - parseInt(b.getAttribute('data-orden'), 10);
      });
      var nCon = 0;
      var nSin = 0;
      cards.forEach(function (c) {
        if (pgrid && c.classList.contains('mxm-c--sin')) { pgrid.appendChild(c); nSin++; }
        else { main.appendChild(c); nCon++; }
      });
      if (pleg && pgrid && pbtn) {
        pleg.hidden = nSin === 0;
        if (nSin === 0) { pgrid.hidden = true; pbtn.setAttribute('aria-expanded', 'false'); }
        var abierto = pbtn.getAttribute('aria-expanded') === 'true';
        pgrid.hidden = !abierto;
        if (nSin === 1) pbtn.textContent = (abierto ? 'Ocultar el 1 sin tu talla' : 'Ver 1 sin tu talla');
        else pbtn.textContent = (abierto ? 'Ocultar los ' : 'Ver los ') + nSin + ' sin tu talla';
      }
      if (filtro) {
        if (!t) {
          filtro.hidden = true;
          filtro.innerHTML = '';
        } else {
          var nom = sec.getAttribute('data-nombre') || '';
          var txt = nCon === 0
            ? 'Ningún ' + esc(nom) + ' en tu talla ' + esc(t) + ' por ahora.'
            : 'En tu talla ' + esc(t) + ': ' + nCon + ' de ' + (nCon + nSin) + '.';
          filtro.innerHTML = '<span>' + txt + '</span><button type="button" data-cambiar>Cambiar talla</button>';
          filtro.hidden = false;
        }
      }
    }

    function aplicar() {
      pintarFilas();
      tarjetas.forEach(pintarTarjeta);
      secciones.forEach(pintarSeccion);
    }

    function elegir(g, t, desdeFila) {
      if (!g || !tallas[g]) return;
      t = normTalla(g, t);
      sel[g] = (desdeFila && sel[g] === t) ? null : t;
      guardarLS(LS[g], sel[g]);
      tarjetas.forEach(function (c) { c.removeAttribute('data-abierta'); });
      aplicar();
      if (sel[g]) clarityEv('mxm_talla_' + g);
    }

    /* ---------- Navegación fija ---------- */
    function irA(el) {
      if (!el) return;
      try { el.scrollIntoView({ behavior: 'smooth', block: 'start' }); } catch (e) { el.scrollIntoView(); }
    }
    function espiar() {
      if (!nav || !botonesNav.length) return;
      var rn = nav.getBoundingClientRect();
      var actual = botonesNav[0].getAttribute('data-ir');
      /* Mientras la barra no se pegó arriba, el título «Todas las prendas» queda justo encima de ella
         (borde con borde) y manda «Todo». Pegada = el título ya se fue hacia arriba. */
      var cab = document.getElementById(actual);
      var pegada = !cab || cab.getBoundingClientRect().bottom < rn.top - 0.5;
      if (pegada) {
        botonesNav.forEach(function (b, i) {
          if (i === 0) return;
          var el = document.getElementById(b.getAttribute('data-ir'));
          if (el && el.getBoundingClientRect().top <= rn.bottom + 12) actual = b.getAttribute('data-ir');
        });
      }
      botonesNav.forEach(function (b) {
        b.setAttribute('aria-current', String(b.getAttribute('data-ir') === actual));
      });
    }
    var pendiente = false;
    window.addEventListener('scroll', function () {
      if (pendiente) return;
      pendiente = true;
      window.requestAnimationFrame(function () { pendiente = false; espiar(); });
    }, { passive: true });

    /* ---------- Carrito ---------- */
    function actualizarSecciones(secs, vacio) {
      if (!secs) return;
      var burbuja = document.getElementById('cart-icon-bubble');
      if (burbuja && secs['cart-icon-bubble']) {
        var hb = htmlSeccion(secs['cart-icon-bubble'], '.shopify-section');
        if (hb != null) burbuja.innerHTML = hb;
      }
      var drawer = document.querySelector('cart-drawer');
      var cont = document.getElementById('CartDrawer');
      if (drawer && cont && secs['cart-drawer']) {
        var hd = htmlSeccion(secs['cart-drawer'], '#CartDrawer');
        if (hd != null) {
          cont.innerHTML = hd;
          if (vacio === true) drawer.classList.add('is-empty');
          else if (vacio === false) drawer.classList.remove('is-empty');
          var ov = drawer.querySelector('#CartDrawer-Overlay');
          if (ov && typeof drawer.close === 'function') ov.addEventListener('click', drawer.close.bind(drawer));
        }
      }
    }

    function pintarBarra(n, aplicado, otro) {
      var barra = raiz.querySelector('[data-mxm-barra]');
      if (!barra) return;
      var txt = barra.querySelector('[data-mxm-barra-txt]');
      var texto;
      if (n <= 0) texto = TXT.b0;
      else if (n < U1) texto = otro ? 'Llevas ' + n + (n === 1 ? ' prenda' : ' prendas') + ' de la colección.' : TXT.b1;
      else if (!aplicado) texto = String(TXT.bsin || '').split('{n}').join(String(n));
      else if (n < U2) texto = TXT.b2;
      else texto = TXT.b3;
      texto = String(texto || '');
      if (txt) {
        var corte = texto.indexOf('aplicado');
        if (aplicado && n >= U1 && corte > -1) {
          txt.innerHTML = '<b>' + esc(texto.slice(0, corte + 8)) + '</b>' + esc(texto.slice(corte + 8));
        } else {
          txt.textContent = texto;
        }
      }
      [].forEach.call(barra.querySelectorAll('[data-paso]'), function (li) {
        li.classList.toggle('is-on', n >= parseInt(li.getAttribute('data-paso'), 10));
      });
    }

    function refrescarBarra() {
      fetch(RUTA_CART + '.js', { headers: { 'Accept': 'application/json' }, credentials: 'same-origin', cache: 'no-store' })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          var n = 0;
          var aplicado = false;
          var otro = false;
          (cart.items || []).forEach(function (it) {
            var esDeLaColeccion = IDS.indexOf(Number(it.product_id)) !== -1;
            if (esDeLaColeccion) n += it.quantity;
            (it.line_level_discount_allocations || []).forEach(function (a) {
              var titulo = (a.discount_application && a.discount_application.title) || '';
              if (esMxm(titulo)) { if (esDeLaColeccion) aplicado = true; } else if (titulo) otro = true;
            });
          });
          ultimoConteo = cart.item_count || 0;
          pintarBarra(n, aplicado, otro);
        })
        .catch(function () {});
    }

    function agregar(btn) {
      if (btn.disabled) return;
      var id = parseInt(btn.getAttribute('data-add'), 10);
      if (!id) return;
      var original = btn.textContent;
      btn.disabled = true;
      btn.textContent = 'Agregando…';
      var cuerpo = {
        items: [{ id: id, quantity: 1 }],
        sections: 'cart-drawer,cart-icon-bubble',
        sections_url: window.location.pathname
      };
      fetch(RUTA_ADD + '.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify(cuerpo)
      })
        .then(function (r) {
          return r.json().then(function (j) { return { ok: r.ok, j: j }; }, function () { return { ok: r.ok, j: {} }; });
        })
        .then(function (res) {
          if (!res.ok) { var err = new Error('add'); err.status = res.j && res.j.status; throw err; }
          btn.classList.add('mxm-btn--hecho');
          btn.textContent = '✓ Agregado';
          actualizarSecciones(res.j.sections, false);
          refrescarBarra();
          clarityEv('mxm_agregar');
          setTimeout(function () {
            if (!document.body.contains(btn)) return;
            btn.classList.remove('mxm-btn--hecho');
            btn.textContent = original;
            btn.disabled = false;
          }, 1600);
        })
        .catch(function (err) {
          btn.textContent = (err && Number(err.status) === 422) ? 'Ya no queda, elige otra' : 'No se pudo, reintenta';
          setTimeout(function () {
            if (!document.body.contains(btn)) return;
            btn.textContent = original;
            btn.disabled = false;
          }, 1800);
        });
    }

    function verCarrito(e, a) {
      var drawer = document.querySelector('cart-drawer');
      if (!drawer || typeof drawer.open !== 'function' || !document.getElementById('CartDrawer')) return;
      e.preventDefault();
      fetch(window.location.pathname + '?sections=cart-drawer,cart-icon-bubble', {
        headers: { 'Accept': 'application/json' }, credentials: 'same-origin'
      })
        .then(function (r) { if (!r.ok) throw new Error('sec'); return r.json(); })
        .then(function (secs) {
          actualizarSecciones(secs, ultimoConteo === null ? null : ultimoConteo === 0);
          drawer.open(a);
        })
        .catch(function () { window.location.href = a.getAttribute('href') || RUTA_CART; });
    }

    /* ---------- Clics ---------- */
    raiz.addEventListener('click', function (e) {
      var b = e.target && e.target.closest ? e.target.closest('button, a') : null;
      if (!b || !raiz.contains(b)) return;
      var card = b.closest('[data-mxm-card]');
      if (b.hasAttribute('data-abrir') && card) {
        card.setAttribute('data-abierta', '1');
        pintarTarjeta(card);
        var primera = card.querySelector('[data-elige]');
        if (primera) primera.focus();
      } else if (b.hasAttribute('data-elige')) {
        elegir(b.getAttribute('data-g'), b.getAttribute('data-elige'), false);
      } else if (b.hasAttribute('data-color') && card) {
        var pid = card.getAttribute('data-pid');
        var color = b.getAttribute('data-color');
        colorSel[pid] = color;
        tarjetas.forEach(function (x) { if (x.getAttribute('data-pid') === pid) pintarTarjeta(x); });
        [].forEach.call(card.querySelectorAll('[data-color]'), function (x) {
          if (x.getAttribute('data-color') === color) x.focus();
        });
      } else if (b.hasAttribute('data-add')) {
        agregar(b);
      } else if (b.hasAttribute('data-mxm-pleg-btn')) {
        var sec = b.closest('[data-mxm-sec]');
        b.setAttribute('aria-expanded', String(b.getAttribute('aria-expanded') !== 'true'));
        if (sec) pintarSeccion(sec);
      } else if (b.hasAttribute('data-cambiar')) {
        irA(document.querySelector('[data-mxm-ancla-tallas]'));
      } else if (b.hasAttribute('data-ir')) {
        irA(document.getElementById(b.getAttribute('data-ir')));
      } else if (b.hasAttribute('data-mxm-ver-carrito')) {
        verCarrito(e, b);
      }
    });

    ['jean', 'body'].forEach(function (g) {
      var fila = filas[g];
      if (!fila || fila.getAttribute('data-mxm-ligado')) return;
      fila.setAttribute('data-mxm-ligado', '1');
      fila.addEventListener('click', function (e) {
        var b = e.target && e.target.closest ? e.target.closest('[data-talla]') : null;
        if (!b) return;
        elegir(g, b.getAttribute('data-talla'), true);
      });
    });

    aplicar();
    espiar();
    refrescarBarra();
    try {
      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
        subscribe(PUB_SUB_EVENTS.cartUpdate, function () { refrescarBarra(); });
      }
    } catch (e) {}
    window.addEventListener('pageshow', function (ev) { if (ev.persisted) refrescarBarra(); });
  }

  function iniciar() {
    var raices = document.querySelectorAll('[data-mxm-raiz]');
    for (var i = 0; i < raices.length; i++) {
      if (raices[i].getAttribute('data-listo')) continue;
      raices[i].setAttribute('data-listo', '1');
      try { arrancar(raices[i]); } catch (e) { if (window.console) window.console.error('mxm-combo', e); }
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', iniciar);
  else iniciar();
  document.addEventListener('shopify:section:load', iniciar);
})();
